var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Storage } from "../../../../lib/localstorege.service";
import { dateTimeFormat, initialLeftMenu, sportsMenu } from "../../../../lib/misc.functions";
import { supportDetailSubject } from "../../subpages/support/support.requests";
import Modal from "react-modal";
import ExitIcon from "../../../../assets/feather/x-circle.svg";
import { modalServiceSubject } from "../../../../components/modal/modal";
import { SupportApi } from "../../subpages/support/support.api";
import { Link } from "react-router-dom";
var SupportDetail = function () {
    var token = Storage.get('token');
    var _a = useState(null), support = _a[0], setSupport = _a[1];
    var _b = useState(null), couponResponse = _b[0], setCouponResponse = _b[1];
    function closeModal() {
        setSupport(null);
    }
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        var supportDetailSubject_subscription = supportDetailSubject.subscribe(function (res) {
            getSupportDetail(res);
        });
        return function () {
            supportDetailSubject_subscription.unsubscribe();
        };
    }, []);
    function getSupportDetail(data) {
        var requestData = {
            id: data.id,
            token: token
        };
        if (data.id) {
            SupportApi.supportDetail(requestData).then(function (result) {
                if (result.status) {
                    setSupport(result.data[0]);
                }
                else {
                    modalServiceSubject.next({
                        title: "Hata!",
                        content: result.message,
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 0
                    });
                }
                supportResponse(result.data[0]);
            });
        }
    }
    function supportResponse(data) {
        var requestData = {
            token: token,
            ticket: data.id,
            ordering: 'create_date'
        };
        SupportApi.supportDetailResponse(requestData).then(function (result) {
            if (result.status) {
                setCouponResponse(result.data[0]);
            }
            else {
                modalServiceSubject.next({
                    title: "Hata!",
                    content: result.message,
                    confirm: {
                        cancel: { label: 'Tamam' }
                    },
                    timeout: 0
                });
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ isOpen: support ? true : false, onRequestClose: closeModal, style: {
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    maxWidth: 'calc(100vw - 40px)',
                    width: '920px',
                    padding: '0px',
                    maxHeight: 'calc(100vh - 100px)',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--color-bg-white)',
                },
            }, contentLabel: "" }, { children: support ? _jsx("div", __assign({ className: "page" }, { children: _jsxs("div", __assign({ className: "card" }, { children: [_jsxs("div", __assign({ className: "card-title pl-md-4 pl-3" }, { children: [_jsxs("h3", { children: [support.id, " Numaral\u0131 Destek Talebi"] }, void 0), _jsx("img", { src: ExitIcon, width: 16, className: "float-right invert-color", onClick: function () { return closeModal(); } }, void 0)] }), void 0), _jsxs("div", __assign({ className: "card-body pt-0" }, { children: [_jsxs("h4", __assign({ className: "justify-content-start pl-1" }, { children: ["Konu: ", support.get_subject_display] }), void 0), _jsxs("div", __assign({ className: "coupon mt-0" }, { children: [_jsx("div", __assign({ className: "header" }, { children: _jsxs("div", __assign({ className: "desc w-100 " }, { children: [_jsxs("div", { children: [" ", support.message, " "] }, void 0), _jsx("div", __assign({ className: "approve-date float-right" }, { children: dateTimeFormat(support.create_date) }), void 0)] }), void 0) }), void 0), couponResponse ? (_jsx("div", __assign({ className: "header", style: { boxShadow: '0px 0px 6px 0px gray', borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px' } }, { children: _jsxs("div", __assign({ className: "desc my-2 w-100 mt-4 mb-2 pl-1" }, { children: [_jsx("div", __assign({ className: "font-weight-bold" }, { children: "~ Oley.com" }), void 0), _jsx("div", { dangerouslySetInnerHTML: { __html: couponResponse.message } }, void 0), _jsx("div", __assign({ className: "approve-date float-right" }, { children: dateTimeFormat(couponResponse.create_date) }), void 0)] }), void 0) }), void 0)) : ('')] }), void 0), _jsxs("div", { children: [_jsx("br", {}, void 0), _jsx(Link, __assign({ to: "/bize-yazin", className: "btn btn-small btn-primary float-right" }, { children: "Destek Talebi Olu\u015Ftur" }), void 0)] }, void 0)] }), void 0)] }), void 0) }), void 0) : _jsx(_Fragment, {}, void 0) }), void 0) }, void 0));
};
export default SupportDetail;
